import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import ApplicationSerializer from 'lumen/serializers/application';

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class ReviRemainingElementSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    value: { embedded: 'always' },
    referenceValue: { embedded: 'always' },
    forecastReference: { embedded: 'always' },
  };
}
